// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xCoveoHandlerType } from "@eisinc/App/CoveoConnector/Store/Reducers";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

export const DispatchUpdateCoveo: Handler<xCoveoHandlerType> = props => {
    props.dispatch({
        type: "xCoveo/update",
        trackCoveo: props.parameter.trackCoveo,
    } as any);
};

const xCoveoUpdate = createHandlerChainRunner([DispatchUpdateCoveo], "xCoveoUpdate");
export default xCoveoUpdate;
